<template>
  <v-sheet color="primary" style="">
    <v-container class="mb-6 mt-n10">
      <v-row align="center" justify="center">
        <v-col cols="12" md="8" lg="8">
          <h1 style="font-weight: bold; color: white; font-size: 50px">
            {{ $t('landing.title') }}
          </h1>
          <h2 class="text-h5 text-sm-h4 white--text mt-4">
            {{ $t('landing.subtitle') }}
          </h2>
          <div class="mt-4 mt-xl-10">
            <v-btn
              x-large
              class="ma-1 mx-sm-1 w-sm-auto"
              color="secondary"
              @click="$router.push('/products')"
            >
              {{ $t('landing.btn') }}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="4" lg="4">
          <v-img
            :max-height="250"
            :max-width="214.2"
            :src="ImgBlockchain"
            alt=""
            class="ma-12 justify-center"
          >
          </v-img>
        </v-col>
      </v-row>
    </v-container>
    <div id="waveTop"></div>
  </v-sheet>
</template>

<script>
import LogoCriptonomia from 'Assets/Landing/logoC_red.png';
import ImgBlockchain from 'Assets/Landing/blockchain1.png';
export default {
  name: 'Landing',
  data() {
    return {
      LogoCriptonomia,
      ImgBlockchain,
    };
  },
  components: {},
};
</script>
<style>
#waveTop {
  position: relative;
  height: 90px;
  width: '100%';
  background: #001e4a;
  border-color: #001e4a;
  border-width: 2px;
}
#waveTop:after {
  content: '';
  display: block;
  border-radius: 100% 100% 0% 0%;
  border-color: white;
  border-width: 2px;
  width: '120%';
  height: 100px;
  background-color: white;
  transform: rotate(0deg);
}
</style>
